import { render, staticRenderFns } from "./illustration-todo.vue?vue&type=template&id=3cd19af9&"
import script from "./illustration-todo.vue?vue&type=script&lang=js&"
export * from "./illustration-todo.vue?vue&type=script&lang=js&"
import style0 from "./illustration-todo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports